export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('vue:error', err => {
    console.log('vue:error', err)
  })
  nuxtApp.vueApp.config.errorHandler = (error, context) => {
    console.log(error)
    console.log(context)
  }
})
